





















import { Component, Prop, Model, Vue, Watch } from 'vue-property-decorator'

@Component
export default class CardTabbed extends Vue {

    @Prop(Array) tabs!: any
    @Model('change', { type: Boolean }) removeContentPadding!: boolean

    active: any = null

    mounted() {
        // Set the first tab as active by default
        if (this.tabs && this.tabs.length > 0) {
            this.active = this.tabs[0].title
            this.$emit('change', this.active)
        }
    }

    @Watch('active')
    onActiveTabChange(newTab: string) {
        this.$emit('change', newTab)
    }
}

